<template>
  <v-layout justify-center class="nx-content-editor-preview fill-height">
    <iframe
      v-if="showIframe"
      ref="iframe"
      :key="defaultPreviewKey"
      :src="previewUrl"
      :style="iframeStyle"
      @load="loading = false"
      class="elevation-1"
      frameborder="0"
    ></iframe>
    <v-progress-linear v-if="loading"
                       :style="loaderStyle"
                       class="loader mt-0 pt-0"
                       indeterminate
                       color="accent"
                       height="4">
    </v-progress-linear>
    <nx-display-mode-selector
      @input="onDisplayModeChange"
      :currentMode="displayMode"
      :displayModes="displayModes"
      :additionalModes="additionalModes"
      :preview-url="previewUrl"
      type="content">
    </nx-display-mode-selector>
  </v-layout>
</template>

<script>
import Storable from '@/mixins/storable';
import NxDisplayModeSelector from '@/components/buttons/DisplayModeSelector';
import { displayModesContentEditor as displayConfig } from '@/modules/board/config';
import { mapGetters } from 'vuex';

export default {
  name: 'nx-content-editor-preview',
  mixins: [Storable],
  components: {
    NxDisplayModeSelector,
  },
  props: {
    show: Boolean,
    editorStorePath: {
      type: [String, Array],
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      displayMode: displayConfig.defaultDisplayMode,
      displayModes: displayConfig.displayModes,
    };
  },
  computed: {
    ...mapGetters('scrollytelling', [
      'defaultPreviewKey',
    ]),
    storePath() {
      return this.editorStorePath;
    },
    previewUrl() {
      return this.getters.previewUrl;
    },
    preloadPreview() {
      return this.getters.preloadPreview;
    },
    isDirty() {
      return this.state.isDirty;
    },
    additionalModes() {
      return displayConfig.additionalModes.map(mode => ({ ...mode, disabled: this.isDirty }));
    },
    selectedMode() {
      return this.displayModes[this.displayMode] || { width: '100%' };
    },
    iframeStyle() {
      return {
        'max-width': this.selectedMode.width,
        'background-color': this.loading ? '#F7F7FA' : 'none',
      };
    },
    loaderStyle() {
      return {
        'max-width': this.selectedMode.width,
      };
    },
    showIframe() {
      if (this.show) {
        return true;
      }
      return this.preloadPreview;
    },
  },
  methods: {
    async reload(additionalQueryParams = {}) {
      if (this.loading) {
        return;
      }
      if (this.$refs.iframe
        && this.previewUrl
      ) {
        this.loading = true;
        const url = new URL(this.previewUrl);
        Object.entries(additionalQueryParams).forEach(([key, val]) => {
          url.searchParams.set(key, val);
        });
        await this.dispatch('FORCE_PREVIEW_URL', url.href);
        this.$refs.iframe.src = url.href;
      }
    },
    onDisplayModeChange(displayMode) {
      this.displayMode = displayMode;
    },
  },
  watch: {
    showIframe(value) {
      if (value) {
        this.loading = true;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.nx-content-editor-preview {
  margin-left: 16px;
  iframe {
    width: 50vw;
    height: calc(100vh - 280px);
    position: fixed;
    background-color #F7F7FA;
  }

  .loader {
    width: 50vw;
    position: fixed;
  }
}
</style>
